import { parseDate } from 'utils/format';
import { apiClientHeadRequest, apiClientPostRequest } from './backendRequest';

const ancestryAuth = (userData, onUpdate = () => { }) => {
  /**
   * Check if current access_token is still valid.
   * Token expires in 60 minutes.
   * @returns {boolean}
   */
  const isTokenValid = () => {
    if (userData.ancestry_token?.access_token) {
      const expiresIn = userData.ancestry_token?.expires_in;
      if (expiresIn) {
        return parseDate(expiresIn) > Date.now();
      }
    }
    return false;
  };

  /**
   * Check if current access_token is at least refreshable by backend service.
   * Refresh is possible in 7 days.
   * @returns {boolean}
   */
  const isTokenRefreshable = () => {
    const refreshableExpiresIn = userData.ancestry_token?.refresh_expires_in;
    if (refreshableExpiresIn) {
      return parseDate(refreshableExpiresIn) > Date.now();
    }
    return false;
  };

  const refreshToken = async () => {
    try {
      const response = await apiClientPostRequest(
        'api/v1/ancestry/refresh',
        {},
        {
          Authorization: `Token ${userData.access_token}`,
        },
      );

      const json = await response.json();

      return {
        data: json.data,
      };
    } catch (e) {
      return { error: e };
    }
  };

  const isFamilysearchTokenValid = async () => {
    try {
      const response = await apiClientHeadRequest(
        'api/v1/familysearch/trees',
        {
          Authorization: `Token ${userData.access_token}`,
        },
      );

      if (response.ok) {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  };

  return {
    getToken: async (type = "ancestry") => {
      if (type === "familysearch") {
        if (userData.familysearch_token?.access_token) {
          const isValid = await isFamilysearchTokenValid();
          if (isValid) {
            return { data: userData.familysearch_token.access_token };
          }
        }
        return { error: { code: 401, body: 'FamilySearch Token is not valid.' } };
      }

      if (isTokenValid()) {
        return { data: userData.ancestry_token.access_token };
      }

      if (isTokenRefreshable()) {
        const { data, error } = await refreshToken();
        if (data) {
          onUpdate(data);
          return { data: data.access_token };
        }
        return { error };
      }

      return { error: { code: 401, body: 'Ancestry Token is not valid.' } };
    },
  };
};

export default ancestryAuth;
